import { calculatePercentDiscountCentavos } from "./money";

export function buildReceiptItems({
  items = [],
  isPlanBound = () => false,
  seniorPwdEligible = false,
  seniorPwdPct = 0,
} = {}) {
  return items.map((item) => {
    const qty = Math.max(1, Number(item?.qty || 1));
    const price = Number(item?.performed_price_centavos || 0);
    const subtotal = qty * price;
    const manualDiscount = Math.max(0, Number(item?.item_discount_centavos || 0));
    const seniorPwdDiscount = seniorPwdEligible && !isPlanBound(item)
      ? calculatePercentDiscountCentavos(subtotal, seniorPwdPct)
      : 0;
    const totalDiscount = Math.min(subtotal, manualDiscount + seniorPwdDiscount);

    return {
      ...item,
      receipt_manual_discount_centavos: manualDiscount,
      receipt_senior_pwd_discount_centavos: seniorPwdDiscount,
      receipt_total_discount_centavos: totalDiscount,
      receipt_net_centavos: subtotal - totalDiscount,
      receipt_is_plan_bound: !!isPlanBound(item),
    };
  });
}

export function receiptDiscountLabel({ seniorPwdDiscountCentavos = 0, otherDiscountCentavos = 0 } = {}) {
  const hasSeniorPwd = Number(seniorPwdDiscountCentavos || 0) > 0;
  const hasOther = Number(otherDiscountCentavos || 0) > 0;
  if (hasSeniorPwd && hasOther) return "SC/PWD Discount + Other Discounts";
  if (hasSeniorPwd) return "SC/PWD Discount";
  return "Discounts";
}
